import type { LocalisedDateFn } from '@archipro-website/localisation';

type DateInput = number | string | Date | null | undefined;

export const getFormattedLocalisedDate = (
    localisedFn: LocalisedDateFn,
    date: DateInput,
    format = 'DD MMMM YYYY'
) => {
    const dateObj = date ? new Date(date) : new Date();
    return localisedFn(dateObj)?.format(format);
};
